import { gql } from '@apollo/client'
import GolferProfileFragment from 'fragments/student/golferProfile'

export const REGISTER_PGA_HOPE_GROUP_EVENT = gql`
  mutation RegisterPgaHopeGroupEvent(
    $id: ID!
    $params: PGAHopeRegisterGroupEventInput!
  ) {
    registerPgaHopeGroupEvent(id: $id, params: $params) {
      success
      message
    }
  }
`
export const PGA_HOPE_PARTICIPATION = gql`
  query pgaHopeParticipation($email: String!, $dateOfBirth: ISO8601Date!) {
    pgaHopeParticipation(email: $email, dateOfBirth: $dateOfBirth) {
      previouslyParticipated
    }
  }
`
export const CURRENT_USER_INFO = gql`
  ${GolferProfileFragment}
  query currentUserDemographicInfo {
    currentUser {
      attributes {
        ... on Contact {
          representatives {
            relationshipType
            student {
              id
              firstName
              lastName
              dateOfBirth
              isMinor
              golferProfile {
                ...GolferProfileAttributes
              }
              pgaHopeProfile {
                id
                accommodations
                additionalInfo
                golfCareerInterest
                golfExperience
                handedness
                hasOwnClubs
                militaryStatus
                referralSource
                serviceBranch
                serviceYearStart
                serviceYearEnd
                zipCode
              }
              contact {
                email
                phone
              }
            }
          }
        }
      }
    }
  }
`
